import { Injectable } from '@angular/core';


import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { SharedSettings } from '../models/shared-settings';
import { BrowserProviderService } from './browser-provider.service';

@Injectable({
    providedIn: 'root'
})
export class LoggingService {

    private appInsights: ApplicationInsights = null;

    constructor(private settings: SharedSettings, private browser: BrowserProviderService) {
        if (this.settings.appInsightsKey) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: this.settings.appInsightsKey
                }
            });

            this.appInsights.loadAppInsights();

            setInterval(() => {
                this.appInsights.flush();
            }, 30 * 1000);
        }
    }

    info(name: string, data?: { [key: string]: any }): void {
        if (this.appInsights)
            this.appInsights.trackEvent({
                name,
                properties: {
                    severity: 'info',
                    ...data
                }
            });
        else
            this.browser.console.info(name, data);
    }

    warning(name: string, data?: { [key: string]: any }): void {
        if (this.appInsights)
            this.appInsights.trackEvent({
                name,
                properties: {
                    severity: 'warning',
                    ...data
                }
            });
        else
            this.browser.console.warn(name, data);
    }

    error(name: string, data?: { [key: string]: any }): void {
        if (this.appInsights)
            this.appInsights.trackEvent({
                name,
                properties: {
                    severity: 'error',
                    ...data
                }
            });
        else
            this.browser.console.error(name, data);
    }

    exception(exception: Error, data?: { [key: string]: any }): void {
        if (this.appInsights) {
            this.appInsights.trackException({
                exception,
                properties: data
            });
        }

        this.browser.console.error(exception, data);
    }

    setUser(userId: string): void {
        if (this.appInsights)
            this.appInsights.setAuthenticatedUserContext(userId);
    }
}
